import { render, staticRenderFns } from "./EmailModal.vue?vue&type=template&id=0847b25c&scoped=true"
import script from "./EmailModal.vue?vue&type=script&lang=js"
export * from "./EmailModal.vue?vue&type=script&lang=js"
import style0 from "./EmailModal.vue?vue&type=style&index=0&id=0847b25c&prod&lang=scss&scoped=true"
import style1 from "./EmailModal.vue?vue&type=style&index=1&id=0847b25c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0847b25c",
  null
  
)

export default component.exports